import { gql } from '@apollo/client';

export const CREATE_VENDOR_REPRESENTATIVE = gql`
  mutation CreateVendorRepresentative($vendorId: String!, $vendorRepresentative: VendorRepresentativeInput!) {
    createVendorRepresentative(vendorId: $vendorId, vendorRepresentative: $vendorRepresentative) {
      email
      firstName
      id
      lastName
      roles
    }
  }
`;
